import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionFridgeLookingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionFridgeLooking.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionFridgeLooking.button1'),
          value: 'well_stocked',
        },
        {
          text: t('pages.onboarding.questionFridgeLooking.button2'),
          value: 'moderately_stocked',
        },
        {
          text: t('pages.onboarding.questionFridgeLooking.button3'),
          value: 'minimal',
        },
        {
          text: t('pages.onboarding.questionFridgeLooking.button4'),
          value: 'nearly_empty',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
